import { render } from "./VerificationPage.vue?vue&type=template&id=c12d2ea6&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=c12d2ea6&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12d2ea6"]])

export default __exports__